// Client-side validators for the client + farm create flow. Mirror the API
// constraints (api-reference) for instant feedback; the backend Joi layer
// remains the source of truth and its field errors still surface inline.

import { cleanName } from './normalize';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const MAX_NAME = 120;
const MAX_DOCUMENT = 40;
const MAX_PHONE = 40;
const MAX_EMAIL = 180;

// Returns a { field: message } map; empty object means valid.
export function validateClient(form) {
    const errors = {};
    const name = cleanName(form.name);

    if (!name) errors.name = 'El nombre es obligatorio.';
    else if (name.length > MAX_NAME) errors.name = `Máximo ${MAX_NAME} caracteres.`;

    if (form.document && form.document.trim().length > MAX_DOCUMENT) {
        errors.document = `Máximo ${MAX_DOCUMENT} caracteres.`;
    }
    if (form.phone && form.phone.trim().length > MAX_PHONE) {
        errors.phone = `Máximo ${MAX_PHONE} caracteres.`;
    }
    if (form.email) {
        const email = form.email.trim();
        if (!EMAIL_RE.test(email)) errors.email = 'Correo no válido.';
        else if (email.length > MAX_EMAIL) errors.email = `Máximo ${MAX_EMAIL} caracteres.`;
    }
    return errors;
}

// Returns a { field: message } map for a single farm row.
export function validateFarm(farm) {
    const errors = {};
    const name = cleanName(farm.name);

    if (!name) errors.name = 'Nombre de finca obligatorio.';
    else if (name.length > MAX_NAME) errors.name = `Máximo ${MAX_NAME} caracteres.`;

    if (farm.size !== '' && farm.size != null) {
        const size = Number(farm.size);
        if (Number.isNaN(size) || size <= 0) errors.size = 'Debe ser un número mayor a 0.';
    }
    return errors;
}
